"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";

const Smile4MeApproach: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          The Smile4Me Approach to Clear Aligner Treatment
        </h2>
        <div className="relative w-full h-[300px] md:h-[500px] my-8 rounded-lg overflow-hidden shadow-lg">
          <Image
            src="/images/Smiling-woman-holding-clear-aligners-between-her-fingers-showing-invisalign-benefits-blurred-background-with-neutral-lighting-and-focus-on-transparent-teeth-straightening-tray.webp"
            alt="Smiling-woman-holding-clear-aligners-between-her-fingers-showing-invisalign-benefits-blurred-background-with-neutral-lighting-and-focus-on-transparent-teeth-straightening-tray"
            fill
            className="object-cover"
            sizes="(max-width: 768px) 100vw, 50vw"
          />
        </div>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          Every treatment plan at Smile4Me Dental Care is fully personalized,
          from your initial consultation to the final reveal of your new
          smile.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          Here&apos;s what sets our approach apart:
        </p>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>Advanced 3D Scanning:</strong> Digital imaging creates a
            map of your treatment plan so you can preview results before you
            start.
          </li>
          <li>
            <strong>Regular Progress Check-Ups:</strong> Visits every 6-8 weeks
            keep your treatment on track.
          </li>
          <li>
            <strong>Comprehensive In-House Care:</strong> From your first
            consultation to your final retainer fitting, everything happens
            under one roof; no referrals, no runaround.
          </li>
          <li>
            <strong>Experienced Team:</strong> Our{" "}
            <Link
              href="https://maps.google.com/maps?cid=8192593597492375843"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
            >
              dentist in Astoria
            </Link>{" "}
            has a proven record of delivering strong results for patients
            throughout Queens.
          </li>
        </ul>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Choosing the right provider matters just as much as choosing the
          right treatment. At Smile4Me, you get dedicated in-house expertise
          and a process built around your comfort and results.
        </p>
      </div>
    </section>
  );
};

export default Smile4MeApproach;
